import React from 'react';
import _ from 'underscore';

const MultiEquipmentInput = (props) => {
  return (
    <div className="w-full">
      <textarea
        rows={props.rows}
        className="form-field w-full"
        style={{ resize: 'none' }}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        data-testid="multi-equipment-input"
      />
    </div>
  );
};

export default MultiEquipmentInput;
